import {
	type FrontendPlacementMessage,
	type AnyFrontendStage,
} from '@post-office/message-maker-browser/types';

import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';

import PagesIcon from '@atlaskit/icon/core/pages';

import IconTile from '@atlaskit/icon/icon-tile';

import { token } from '@atlaskit/tokens';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

import {
	PlacementFrontend,
	type CustomPlacementProps,
} from '@post-office/browser--growth-starburst/project-assets-ai-suggestions';

import { FormattedMessage } from 'react-intl';

import { type MessageTemplateContext } from '../../..';

import { SuggestionCard } from '@post-office/browser--growth-starburst/common/components/suggestion-card';

export const MessageFrontend: (
	config: CreatePlacementMessageConfig,
) => FrontendPlacementMessage<{ render: AnyFrontendStage }> =
	PlacementFrontend.createMessageFrontend({
		render: {
			validate: noValidation<MessageTemplateContext>(),
			Component: ({ epicKey, onSnoozeClick }: CustomPlacementProps & MessageTemplateContext) => {
				return (
					<SuggestionCard
						icon={<IconTile icon={PagesIcon} label="" appearance="greenBold" size="small" />}
						title={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.project-plan.title"
								defaultMessage="Create a project plan"
								description="Title for the project plan suggestion card"
							/>
						}
						// TODO: Update 'epic' text (might not be Epic type)
						description={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.project-plan.description"
								defaultMessage="Create a project plan for your newly added epic {epicKey} to share with your team."
								description="Description for the project plan suggestion card"
								// TODO: Placeholder, will update with smart link
								values={{
									epicKey: <a href={`https://jira.atlassian.com/browse/${epicKey}`}>{epicKey}</a>,
								}}
							/>
						}
						ctaLabel={
							<FormattedMessage
								id="post-office.project-assets-ai-suggestions.project-plan.cta"
								defaultMessage="Create summary"
								description="CTA button label for the project plan suggestion card"
							/>
						}
						ctaIcon={<AiGenerativeTextSummaryIcon label="" color={token('color.icon.subtle')} />}
						onSnoozeClick={onSnoozeClick}
						onCtaClick={() => {
							// TODO: STARB-3239 open CWR modal
						}}
					/>
				);
			},
		},
	});
